import React from 'react';
import { Box, Breadcrumbs, Paper, Typography } from '@mui/material';
import NotificationCenter from '@/components/notifications/NotificationCenter';
import { ClientDetailsV2MealPlanTab } from '@/clients/details/v2/components/ClientDetailsV2MealPlanTab';

const GenericMealPlansPage: React.FC = () => {
  return (
    <Box sx={{ position: 'relative', py: 1, mt: { lg: 1.5 }, ml: { lg: 0.5 } }}>
      <Paper
        elevation={0}
        sx={{
          minHeight: 'calc(100vh - 7.5rem)',
          overflow: 'hidden',
          borderRadius: '28px',
          border: '1px solid rgba(15, 23, 42, 0.08)',
          bgcolor: '#fff',
        }}
      >
        <div className="space-y-8 p-4 sm:p-5 lg:px-7 lg:pt-6 lg:pb-7">
          <Paper
            elevation={0}
            sx={{
              borderRadius: '16px',
              border: '1px solid #dbe6eb',
              bgcolor: '#fafcfe',
              px: { xs: 2, sm: 3 },
              py: 1.5,
            }}
          >
            <Breadcrumbs separator="/" aria-label="breadcrumb">
              <Typography sx={{ fontFamily: 'Inter, sans-serif', fontSize: '14px', color: '#0f172a' }}>
                Cohort Meal Plans
              </Typography>
            </Breadcrumbs>
          </Paper>

          <Box
            sx={{
              display: 'flex',
              alignItems: { xs: 'flex-start', sm: 'center' },
              justifyContent: 'space-between',
              gap: 2,
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Box sx={{ minWidth: 0 }}>
              <Typography
                component="h1"
                sx={{
                  fontFamily: 'Inter, sans-serif',
                  fontSize: '32px',
                  fontWeight: 500,
                  lineHeight: 1.2,
                  color: '#1D2B2D',
                }}
              >
                Cohort Meal Plans
              </Typography>
              <Typography sx={{ mt: '2px', fontFamily: 'Inter, sans-serif', fontSize: '16px', color: '#717182' }}>
                Run a structured nutrition program for 50, 500, or 5,000 people—while maintaining personalized nutrition care for each participant
              </Typography>
            </Box>
            <NotificationCenter buttonVariant="feature" />
          </Box>

          <ClientDetailsV2MealPlanTab clientId="" genericLibraryOnly />
        </div>
      </Paper>
    </Box>
  );
};

export default GenericMealPlansPage;
